import React, { Component, ErrorInfo, ReactNode } from "react";
import { ErrorContainer } from "../../screens/Error/Error.styles";
import ActionBtnU from "../../screens/User/Users/components/ActionBtnU";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundaryRoute extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  handleHomeButtonClick = () => {
    window.location.replace(`${import.meta.env.VITE_WEB_URL}`);
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <h1>Oops!</h1>
          <h3 className="mb-5">Apologies, this is on us 🤧.</h3>
          <ActionBtnU
            largeWidth
            onClick={this.handleHomeButtonClick}
            purpleBg
            white_color
          >
            Go Home
          </ActionBtnU>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryRoute;
